import { gql } from "@apollo/client";

export default gql`
  mutation fillPositionByPrivateJobRecurringId($data: FillPositionByPrivateJobRecurringIdInput!) {
    fillPositionByPrivateJobRecurringId(data: $data)
  }
`;
